import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core'
import { provideRouter, withComponentInputBinding } from '@angular/router'
import { routes } from './app.routes'
import { provideTranslateService, TranslateModuleConfig } from '@ngx-translate/core'
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc'
import { ToastService } from '@siemens/ix-angular/standalone'
import { environment } from '../environments/environment'

const oauthStorageFactory = (): Storage => localStorage

export const provideTranslation = (): TranslateModuleConfig => ({
  fallbackLang: 'en',
  loader: provideTranslateHttpLoader({
    prefix: './assets/i18n/',
    suffix: '.json',
  }),
})

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    ToastService,
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideRouter(routes, withComponentInputBinding()),
    provideTranslateService(provideTranslation()),
    provideOAuthClient({
      resourceServer: {
        allowedUrls: ['http://localhost:4200', environment.url, environment.presignedUrlEndpoint],
        sendAccessToken: true,
      },
    }),
    { provide: OAuthStorage, useFactory: oauthStorageFactory },
  ],
}
